import { render, staticRenderFns } from "./ConfigBackupFileNameOption.vue?vue&type=template&id=372a0f6a&scoped=true&"
import script from "./ConfigBackupFileNameOption.vue?vue&type=script&lang=js&"
export * from "./ConfigBackupFileNameOption.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "372a0f6a",
  null
  
)

export default component.exports